export const getTimeString = (date) => {
    const addZerosIfNeeded = (number) =>
        number >= 10 ? String(number) : `0${number}`;

    const hours = addZerosIfNeeded(date.getHours());
    const minutes = addZerosIfNeeded(date.getMinutes());

    if (!isNaN(hours) && !isNaN(minutes)) {
        return `${addZerosIfNeeded(date.getHours())}:${addZerosIfNeeded(
            date.getMinutes(),
        )}`;
    } else {
        return "unknown";
    }
};
